import { Grid } from '@mui/material';
import Card from '@mui/material/Card';
import { blue, deepOrange, deepPurple, green, grey, orange, pink, red, teal } from '@mui/material/colors';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { brandColors } from 'types/colors';

import { LabelType, LineChart } from '../../components/Charts/LineChart';
import MDBox from '../../components/MDBox';

const FormattedChart = ({
  title,
  datasets,
  isRange,
  isPopUp,
  setChartPopUp,
  sensorId,
  onChartRangeSelect,
  chartRangeButtons,
  compact = false,
  formatTooltipValue,
  formatDataLabelValue,
  dataLabelIcon,
  dataLabelIconSeries,
  yAxisRange,
  yAxisRanges,
}) => {
  const COLORS_FOR_REGULAR_CHARTS = [
    brandColors.BLUE,
    brandColors.GREY,
    brandColors.TURQUOISE,
    orange[400],
    green[300],
    deepOrange[600],
    pink[500],
    teal[600],
    grey[900],
    grey[500],
    blue[600],
  ];
  const dispatch = useDispatch();

  const COLORS_FOR_RANGE_CHARTS = [
    blue[200],
    orange[400],
    green[300],
    deepOrange[600],
    pink[500],
    teal[600],
    red[300],
    orange[400],
    grey[500],
    deepPurple[600],
    blue[600],
  ];
  const chartColors = (isRange === undefined || isRange === false ? COLORS_FOR_REGULAR_CHARTS : COLORS_FOR_RANGE_CHARTS).map(
    (defaultColor, index) => datasets?.[index]?.color || defaultColor,
  );
  const handleExpand = () => {
    dispatch(
      setChartPopUp({
        title,
        datasets,
        isRange,
        yAxisRange,
        yAxisRanges,
      }),
    );
  };

  return (
    <Grid className="chart-container" item sx={{ width: '100%', height: '100%', minHeight: 0 }}>
      <Card
        sx={{
          height: '100%',
          minHeight: 0,
          borderRadius: 3,
          overflow: 'hidden',
          border: `2px solid ${brandColors.GREY_LIGHT}`,
          display: 'flex',
          flexDirection: 'column',
        }}>
        <MDBox margin={compact ? 0 : 1} style={compact || !isPopUp ? { height: '100%' } : { height: '80vh' }}>
          {datasets && (
            <LineChart
              title={title}
              detailed={true}
              horizontalLabels={undefined}
              datasets={datasets}
              isZoomEnabled={true}
              isLineCurved={false}
              xAxis={{ labelType: LabelType.Date, show: true }}
              onExpand={compact ? undefined : handleExpand}
              isPopUp={isPopUp}
              onChartRangeSelect={onChartRangeSelect}
              chartRangeButtons={chartRangeButtons}
              compactAxes={compact}
              colors={chartColors}
              deviceId={sensorId}
              formatTooltipValue={formatTooltipValue}
              formatDataLabelValue={formatDataLabelValue}
              dataLabelIcon={dataLabelIcon}
              dataLabelIconSeries={dataLabelIconSeries}
              yAxisRange={yAxisRange}
              yAxisRanges={yAxisRanges}
            />
          )}
        </MDBox>
      </Card>
    </Grid>
  );
};

FormattedChart.propTypes = {
  title: PropTypes.string,
  datasets: PropTypes.array,
  isRange: PropTypes.bool,
  isPopUp: PropTypes.bool,
  setChartPopUp: PropTypes.func,
  sensorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChartRangeSelect: PropTypes.func,
  chartRangeButtons: PropTypes.array,
  compact: PropTypes.bool,
  formatTooltipValue: PropTypes.func,
  formatDataLabelValue: PropTypes.func,
  dataLabelIcon: PropTypes.string,
  dataLabelIconSeries: PropTypes.arrayOf(PropTypes.bool),
  yAxisRange: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
  }),
  yAxisRanges: PropTypes.arrayOf(
    PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }),
  ),
};

export default FormattedChart;
